import React from "react";
import { C } from "./theme";

// Texte d'offre : une ligne « - … » devient une puce, **…** passe en gras noir.
const inline = (text, key) => text.split(/(\*\*[^*]+\*\*)/g).map((part, index) => (
  part.startsWith("**") && part.endsWith("**") && part.length > 4
    ? <strong key={`${key}-${index}`} style={{ color: C.black }}>{part.slice(2, -2)}</strong>
    : <React.Fragment key={`${key}-${index}`}>{part}</React.Fragment>
));

export const parseLines = (text) => (text || "").split("\n").map((line) => {
  const bullet = /^\s*[-•]\s+/.exec(line);
  return bullet ? { bullet: true, text: line.slice(bullet[0].length) } : { bullet: false, text: line };
});

const RichText = ({ text, style, placeholder }) => {
  if (!text) {
    return placeholder ? <div style={{ ...style, color: C.line, fontStyle: "italic" }}>{placeholder}</div> : null;
  }
  return (
    <div style={style}>
      {parseLines(text).map((line, index) => (
        line.bullet ? (
          <div key={index} style={{ display: "flex", gap: "0.45em", marginBottom: "0.35em" }}>
            <span aria-hidden="true">•</span>
            <span>{inline(line.text, index)}</span>
          </div>
        ) : (
          <div key={index} style={{ minHeight: "1em", marginBottom: line.text ? "0.2em" : 0 }}>{inline(line.text, index)}</div>
        )
      ))}
    </div>
  );
};

export default RichText;
